import { Injectable } from '@angular/core';
import { WpAjaxService } from '../wp-ajax/wp-ajax.service';
import { Observable } from 'rxjs/Observable';
import { StateFromZip } from './state-from-zip';
import { StateList } from './state-list';

@Injectable()
export class AddressService {

    constructor(
        private http: WpAjaxService
    ) { }

    getStateFromZip(zipCode: string): Observable<StateFromZip> {
        const postData = {
            request_type: 'getStateFromZip',
            zipCode
        };
        return this.http.post_request(postData).map((_r) => {
            const responseData: StateFromZip = _r.data;
            if (responseData.StateForZip) {
                responseData.StateName = this.getStateName(responseData.StateForZip);
            }
            return responseData;
        });
    }

    getStateName(postalState: string) {
        return StateList[postalState];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/address/address.service.ts